import React from 'react';
import { useToast } from '@common/toast';
import { JOBDA_SUPPORT_EMAIL } from '@domain/constant/contact';
import { PHSAnalysisType } from '@domain/constant/phsAnalysisType';

const FailedToast = () => {
  return (
    <div>
      분석오류로 인해 결과표 작성되지 않았어요
      <br />
      <a href={`mailto:${JOBDA_SUPPORT_EMAIL}`}>{JOBDA_SUPPORT_EMAIL}로 문의 주세요.</a>
    </div>
  );
};

interface AccaToastProps {
  type: PHSAnalysisType;
}

const PhsToast = ({ type }: AccaToastProps) => {
  const Toast = useToast();

  switch (type) {
    case 'FAILED':
      return Toast({ iconType: 'info', content: <FailedToast /> });
    default:
      return Toast({ iconType: 'info', content: '분석 완료후 결과표 열람이 가능합니다.' });
  }
};

export default PhsToast;
